export enum Role {
  Unknown = 0,
  User = 1,
  AdvisorStaff = 2,
  Manager = 4,
  AdvisorLead = 8,
  KingAdmin = 32,
  Vendor = 64,
  Training = 128,
  Admin = 256,
  Assessor = 512,
  Survey = 1024,
  PrimaryAdvisorLead = 2048,
  PrimaryManager = 4096,
  Support = 8192,
  IncidentResponse = 16384,
  Engineer = 32768,
  PlatformSupport = 65536,
  TrustCenterViewer = 131072
}

export class RoleHelper {
  public static isDashboardVisible(role: Role): boolean {
    return role != Role.KingAdmin &&
      role != Role.Admin &&
      role != Role.Training &&
      role != Role.Survey &&
      role != Role.IncidentResponse &&
      role != Role.Engineer &&
      role != Role.TrustCenterViewer;
  }

  public static isDocumentsVisible(role: Role): boolean {
    return role != Role.Training &&
      role != Role.Survey &&
      role != Role.Engineer &&
      role != Role.IncidentResponse &&
      role != Role.TrustCenterViewer;
  }

  public static isTenantsVisible(role: Role): boolean {
    return (role & Role.KingAdmin) != 0;
  }

  public static isUsersVisible(role: Role): boolean {
    return (role & (Role.Manager | Role.PrimaryManager)) !=
      0 ||
      (role & Role.KingAdmin) != 0 ||
      (role &
        (Role.AdvisorLead |
          Role.PrimaryAdvisorLead |
          Role.PlatformSupport)) !=
      0;
  }
  public static isVaultVisible(role: Role): boolean {
    return (role & Role.KingAdmin) != 0 ||
      (role &
        (Role.AdvisorLead |
          Role.PrimaryAdvisorLead |
          Role.PlatformSupport)) !=
      0;
  }
  public static isItProfileTemplatesVisible(role: Role): boolean {
    return (role & (Role.Manager | Role.PrimaryManager)) != 0 ||
    (role & (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport | Role.User)) != 0 ||
    (role & Role.KingAdmin) != 0 ||
    (role & Role.Admin) != 0;
  }
}
